import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import MedicalInstitutionEdit from 'ui/pages/admin/MedicalInstitutionLEdit'
import {
  getMedicalInstitution,
  getPartnerCompanies,
  putMedicalInstitution,
} from './fetch'
import {
  AdminMedicalInstitution,
  partnerCompanyProps,
  ApplicationEntryEditFormProps,
} from 'types/med'
import { routePaths } from 'app/routes'
import nullToUndefined from 'ui/utils/nullToUndefined'
import { ApiErrorWithMessage, NotFoundError } from 'app/client'

const AdminMedicalInstitutionEdit: React.FC = () => {
  const navigate = useNavigate()

  const { institution_id } = useParams<'institution_id'>() as {
    institution_id: string
  }

  const [institution, setInstitution] = useState<AdminMedicalInstitution>()
  const [partnerCompanies, setPartnerCompanies] = useState<
    partnerCompanyProps[] | undefined
  >()

  useEffect(() => {
    getPartnerCompanies()
      .then((data) => {
        setPartnerCompanies(data)
        return getMedicalInstitution({
          institution_id: Number(institution_id),
        })
      })
      .then((data) =>
        setInstitution({
          ...data,
          // NOTE: partnerの値を追加しないとバリデーションが不正になるので必須の型にして明示的にセット
          partner: data.partner || {
            partner_company_id: undefined,
            branch_name: '',
            contact_person_name: '',
            email: '',
            phone: '',
            remarks: '',
          },
        })
      )
      .catch((e) => {
        if (e instanceof NotFoundError) {
          navigate('/404')
          return
        }
        navigate('/error')
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    //NOTE: 削除された代理店であればselectのデータに追加
    if (
      partnerCompanies &&
      institution &&
      institution.partner?.partner_company_id &&
      institution.partner?.name &&
      !partnerCompanies.find(
        ({ id }) => id === institution.partner.partner_company_id
      )
    ) {
      setPartnerCompanies([
        ...partnerCompanies,
        {
          id: institution.partner.partner_company_id,
          name: institution.partner.name,
        },
      ])
    }
  }, [partnerCompanies, institution])

  const submitHandler = (data: ApplicationEntryEditFormProps) => {
    return putMedicalInstitution({
      institution_id: Number(institution_id),
      data,
    })
      .then(() => navigate(`${routePaths.admin}`))
      .catch((e) => {
        if (e instanceof ApiErrorWithMessage) {
          throw e
        } else if (e instanceof NotFoundError) {
          navigate('/404')
        } else {
          navigate('/error')
        }
      })
  }

  return partnerCompanies && institution ? (
    <MedicalInstitutionEdit
      defaultValues={nullToUndefined<AdminMedicalInstitution>(institution)}
      partnerCompanies={partnerCompanies}
      onSubmit={submitHandler}
      onClickCancel={() => navigate(`${routePaths.admin}`)}
    />
  ) : null
}

export default AdminMedicalInstitutionEdit
